<template>
  <div>
    <base-heading>Upload File</base-heading>
    <base-text>
      1. Download Template <base-button @click="download">
        Download
      </base-button>
    </base-text>
    <base-text class=" mt-4">
      2. Format a spreadsheet like the example below. (Maximum of 5,000 contacts per spreadsheet)
    </base-text>
    <div class="example mt-4" />
    <base-text class=" mt-4">
      3. Save the file as a .csv (comma separated values)
    </base-text>
    <base-text class=" mt-4">
      4. <input type="file">
    </base-text>
    <div class="mt-4">
      <base-button
        secondary
        expanded
        class="ml-0"
        @click="onSubmit"
      >
        Upload
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadFile',
  data() {
    return {
      list: '',
    };
  },
  methods: {
    onSubmit() {
      if (this.list !== '') {
        this.$emit('onSubmit', this.list);
      }
    },
    download() {
      this.$emit('onDownload');
    },
  },
};
</script>

<style lang="scss" scoped>
.example{
    background-color: $gray-light;
    height: 116px;
    border-radius: 3px;
}
</style>
